import { DropdownV5, Flex, Colors } from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'
import {
  components as ReactSelectComponents,
  SingleValueProps,
  DropdownIndicatorProps,
} from 'react-select'
import { useState } from 'react'
import { ICustomDropdownV5Props } from './custom-dropdown-v5.types'
import { TopLabel, ValueLabel } from './custom-dropdown-v5.styles'

const CustomDropdownV5 = ({
  topLabel,
  icon,
  width = '200px',
  ...rest
}: ICustomDropdownV5Props) => {
  // Keep track of whether the dropdown menu is open to adjust the outer border colour
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const DropdownControl = ({ children, ...props }: any) => {
    // `menuIsOpen` may be provided directly or via `selectProps`
    const isMenuOpen =
      props.menuIsOpen ?? props.selectProps?.menuIsOpen ?? false

    return (
      <ReactSelectComponents.Control
        {...props}
        style={{
          // Change the border colour based on the open state
          borderColor: isMenuOpen ? Colors.primary : Colors.border,
          padding: 0,
        }}
      >
        <FontAwesomeIcon
          icon={icon}
          size="lg"
          color="#c5c5c7"
          style={{
            marginLeft: '14px',
            marginRight: '2px',
          }}
        />
        {children}
      </ReactSelectComponents.Control>
    )
  }

  const DropdownSingleValue = (props: SingleValueProps<any, false>) => (
    <Flex
      alignItems="center"
      height="20px"
      direction="column"
      align="flex-start"
    >
      <TopLabel style={{ marginTop: '-15px' }}>{topLabel}</TopLabel>
      <ValueLabel>{props.data.label}</ValueLabel>
    </Flex>
  )

  // Custom DropdownIndicator to move it to the left
  const DropdownIndicator = (props: DropdownIndicatorProps<any, false>) => (
    <ReactSelectComponents.DropdownIndicator {...props}>
      <FontAwesomeIcon
        icon={faChevronDown}
        size="lg"
        color="#C5C5C7"
        style={{
          marginRight: '10px',
          height: '15px',
          width: '15px',
        }}
      />
    </ReactSelectComponents.DropdownIndicator>
  )

  // Extract potential callbacks from rest so we can chain them
  const { onMenuOpen, onMenuClose, ...dropdownProps } = rest as any

  const handleMenuOpen = (inputValue?: string) => {
    setIsMenuOpen(true)
    if (typeof onMenuOpen === 'function') {
      onMenuOpen(inputValue)
    }
  }

  const handleMenuClose = () => {
    setIsMenuOpen(false)
    if (typeof onMenuClose === 'function') {
      onMenuClose()
    }
  }

  return (
    <DropdownV5
      isOutlined
      size="large"
      width={width}
      rounded
      borderColor={isMenuOpen ? Colors.primary : Colors.border}
      components={{
        Control: DropdownControl,
        SingleValue: DropdownSingleValue,
        DropdownIndicator: DropdownIndicator,
      }}
      onMenuOpen={handleMenuOpen}
      onMenuClose={handleMenuClose}
      {...dropdownProps}
    />
  )
}

export default CustomDropdownV5
